module.exports = __webpack_public_path__ + "img/info4.dd8b6910.jpg";